import { db } from "../../plugins/firebase";
import hmacSHA256 from "crypto-js/hmac-sha256";
export const auth = {
  namespaced: true,
  state: {
    auth: null,
    user: null,
    qrcode: "",
    autostartToken: null,
    qrtimer: null
  },
  getters: {
    auth(state) {
      return state.auth;
    },
    user(state) {
      return state.user;
    },
    autostartToken(state) {
      return state.autostartToken;
    },
    qrcode(state) {
      return state.qrcode;
    }
  },
  mutations: {
    setAuth(state, auth) {
      state.auth = auth;
    },
    setUser(state, user) {
      // eslint-disable-next-line no-undef
      analytics.identify(state.auth.uid, { name: user.name });
      user.contracts?.map(contract => {
        // eslint-disable-next-line no-undef
        analytics.group(contract.id);
      });

      state.user = user;
    },
    setQrcode(state, qrcode) {
      state.qrcode = qrcode;
    },
    setAutostartToken(state, token) {
      state.autostartToken = token;
    },
    setQrTimer(state, qrtimer) {
      if (null != state.qrtimer) {
        clearInterval(state.qrtimer);
        state.qrcode = "";
      }
      state.qrtimer = qrtimer;
    },
    cancelQrTimer(state) {
      clearInterval(state.qrtimer);
      state.qrtimer = null;
      state.qrcode = "";
      state.autostartToken = null;
    }
  },
  actions: {
    auth: async ({ commit }, auth) => {
      commit("setAuth", auth);
    },
    loadUser: async ({ commit }, auth) => {
      if (auth) {
        db.collection("individuals")
          .doc(auth.uid)
          .onSnapshot(async doc => {
            commit("setUser", doc.data());
          });
      }
    },
    startQrUpdater: async ({ commit }, data) => {
      var time = 0;
      const qrStartToken = data.qrStartToken;
      const qrStartSecret = data.qrStartSecret;
      const autostartToken = data.autoStartToken;
      commit("setAutostartToken", autostartToken);
      const qrtimer = setInterval(updateQr, 1000);
      commit("setQrTimer", qrtimer);
      function updateQr() {
        const secret = hmacSHA256(`${time}`, qrStartSecret);
        const qr = `bankid.${qrStartToken}.${time}.${secret}`;
        console.log(`Time: ${time}`);
        commit("setQrcode", qr);
        time++;
        if (time > 30) {
          commit("cancelQrTimer");
        }
      }
    },
    clearQrAndTimer: async ({ commit }) => {
      commit("cancelQrTimer");
    },
    approveTerms: async (_, { uid }) => {
      try {
        await db
          .collection("individuals")
          .doc(uid)
          .set(
            {
              hasAcceptedTerms: true
            },
            { merge: true }
          );

        return true;
      } catch (error) {
        console.log(error);
        return;
      }
    }
  }
};
